module.exports = __webpack_public_path__ + "static/img/img21.60087a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img21.png
// module id = Pi/m
// module chunks = 1